import { EntityState } from '@ngrx/entity';
import { Invoice } from '@app/resources/services';

export interface InvoiceState extends EntityState<Invoice> {
  selectedPastInvoiceId: number | null;
  hasLoaded: boolean;
}
